export enum DynamicContentElementTypeEnum {
  HEADLINE = 'headline',
  HEADLINELETTER = 'headlineletter',
  HEADLINEWITHBORDER = 'headlinewithborder',
  SUB_TITLE = 'sub-title',
  TEXT = 'text',
  TEXTLETTER = 'textletter',
  TEXTITALIC = 'textitalic',
  MEDIA = 'media',
  TILES = 'tiles',
  CARDS = 'cards',
  SPACER = 'spacer',
  USERDATA = 'userdata',
  SIGNATURES = 'signatures',
  TABLE = 'table',
  PAGEBREAK = 'pagebreak',
  LINE = 'line',
  LANDSCAPE_USER_BLOCK = 'landscape-user-block',
  REVIEW_PERIOD_DATA = 'review-period-data',
  ACHIEVEMENT_TABLE = 'achievementtable',
  MERIT_TABLE = 'merit-table',
  GENERAL_MERIT_TABLE = 'general-merit-table',
  IMAGE_SIGNATURES = 'image-signatures',
  TEXT_BULLET = 'textbullet',
  TEXT_BOLD = 'textbold',
  TEXT_LINK = 'textlink'
}
